import React from 'react';
import dayjs from "dayjs";

const OpenDateAlert = ({openDateSetting}) => {
	const getValidDate = (expired_date, valid_days) => {
		if (expired_date) {
			return dayjs(expired_date).format("DD MMM YYYY");
		}

		if (valid_days) {
			return dayjs().add(valid_days, "day").format("DD MMM YYYY");
		}

		return "-"; // fallback
	};

	const formattedValidDate = getValidDate(
		openDateSetting?.expired_date,
		openDateSetting?.valid_days
	);
    return (
        <>
            <div className='brick-background' style={{textAlign:'start', background:'var(--secondary-button-color)', borderRadius:8, marginTop:12,}}>
                <div style={{padding: 24,}}>
                    <div>
                        <span className='ticket-label ticket-title'
                        style={{
                            fontWeight:500,
                            fontSize: 20,
                            // color : 'var(--secondary-text-color)'
                        }}>
                            Open Date Ticket Promo
                        </span>
                    </div>
                    <div>
                        <span style={{color : 'var(--secondary-text-color)'}}>
                        Valid until {formattedValidDate}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpenDateAlert;